/* eslint-disable new-cap */
const buildCareTeamProviders = (list_data, components, handleButtonClick) =>
  list_data &&
  list_data.map(provider =>
    components.CareTeamProvider({
      provider,
      components,
      onViewProfile: providerItem =>
        handleButtonClick(providerItem, {
          type: "modal_screen",
          value: "CareTeamProfileDetailScreen"
        })
    })
  );

export default buildCareTeamProviders;
